import { usePwaInstall } from "@hooks/usePwaInstall";
import { Button } from "@components/ui";
import { InstallIcon, XIcon } from "@icons";
import { useState } from "react";
import styles from "./InstallPrompt.module.css";

export function InstallPrompt() {
  const { canInstall, promptInstall } = usePwaInstall();
  const [dismissed, setDismissed] = useState(false);
  if (!canInstall || dismissed) return null;
  return (
    <div className={styles.banner}>
      <InstallIcon width={20} height={20} />
      <div className={styles.body}>
        <div className={styles.title}>Install aria</div>
        <div className={styles.sub}>Add to your home screen for the best experience.</div>
      </div>
      <Button size="sm" tint="var(--color-blue)" onClick={promptInstall}>
        Install
      </Button>
      <button
        className={styles.close}
        aria-label="Dismiss"
        onClick={() => setDismissed(true)}
      >
        <XIcon width={16} height={16} />
      </button>
    </div>
  );
}